export default __webpack_public_path__ + "static/website-poster-e4957ea60f2ebdb5c1548eb583ca4f23.jpg";